// Order.js
// Data object for handling order state

// Class Definition
class Order {
  constructor(products, order) {
    this.products = products;
    this.order = order;
  }

  getDateClosed = () => {
    if (!this.order || !this.order.dateClosed)
      return new Date();
    return new Date(this.order.dateClosed);
  }

  getQuantity = (prodId) => {
    var productState = this.order[prodId];
    if (!productState) return 0;
    return productState.quantity;
  }

  getUnit = (prodId) => {
    var product = this.products.byId[prodId];
    var productState = this.order[prodId];
    if (!product || !productState) return null;
    var price = product.price[productState.unitId];
    if (!price) return null;
    return price.unit;
  }

  hasCustomPrice = (prodId) => {
    var prodState = this.order[prodId];
    return prodState && prodState.customPrice;
  }
  
  getCustomPrice = (prodId) => {
    var prodState = this.order[prodId];
    return prodState ? prodState.customPrice : undefined;
  }

  getProductTotal = (prodId) => {
    if (!this.order || !this.order[prodId])
      return 0;

    var prodState = this.order[prodId];
    var prodData = this.products.byId[prodId];

    if (prodState.price)
      return prodState.price;
    else if (prodState.customPrice)
      return prodState.customPrice;
    else if (prodData) {
      var unitData = prodData.price[prodState.unitId];
      if (unitData)
        return unitData.price * prodState.quantity;
    }
    return 0;
  }

  getAdjustmentValue = () => {
    if (!this.order || !this.order.adjustment)
      return 0;
    var value = this.order.adjustment.value;
    return value ? value : 0;
  }
  
  getAdjustmentDescription = () => {
    if (!this.order || !this.order.adjustment)
      return null;
    return this.order.adjustment.description;
  }

  getSubtotal = () => {
    var total = 0;
    for (var prodId in this.order)
      total += this.getProductTotal(prodId);
    return total;
  }

  getTotal = () => {
    var adjust = this.getAdjustmentValue();
    if (!adjust) adjust = 0;
    return this.getSubtotal() + adjust;
  }
}

// Default Export
export default Order;


// WEBPACK FOOTER //
// ./src/data/Order.js